import { AppShell } from '@/components/layout/AppShell';
import { PageHeader } from '@/components/layout/PageHeader';
import { TeamDashboard as TeamDashboardWidget } from '@/tools/inner-team/components/team/TeamDashboard';

export function TeamDashboard() {
  return (
    <AppShell>
      <PageHeader showBrand />
      <div className="flex-1 flex flex-col overflow-hidden">
        <TeamDashboardWidget />
      </div>
    </AppShell>
  );
}
